<template>
	<v-row fill-height>
		<v-col cols="4">
			<CollectionList :title="collection" :collections="collections" @show="showCollection" />

			<v-btn tile color="success" x-large class="mt-4" block @click="newCollection" v-if="adminMode">
				<v-icon left>mdi-folder-plus</v-icon> Add Collection
			</v-btn>
		</v-col>

		<v-col cols="8">
			<CollectionFiles
				@show="showCollection"
				ref="activeFolder"
				v-bind="activeCollection"
				@remove-collection="removeCollection"
				@remove-file="removeFile"
				:uploadFn="uploadFile"
				:adminMode="adminMode"
				:collections="allCollections"
			/>
		</v-col>
	</v-row>
</template>

<script>
import CollectionList from '@/components/n-collections/CollectionList'
import CollectionFiles from '@/components/n-collections/CollectionFiles'

import FileService from '@/services/FileServiceProtected'

import FileCollectionSelector from '@/components/ui/FileCollectionSelector'
import FileCollectionForm from '@/components/dialogs/forms/FileCollectionForm'

import Dialog from '@/components/dialogs/DialogEdit'
import Messages from '@/helpers/message-helper'

import bus from '@/eventbus'
import { mapGetters } from 'vuex'

export default {
	name: 'FileCollections',

	components: {
		CollectionList,
		CollectionFiles,
		FileCollectionSelector
	},

	props: {
		collection: String
	},

	data() {
		return {
			allCollections: [],
			collections: [],
			activeCollection: {
				title: '',
				files: []
			}
		}
	},

	async created() {
		this.setBaseFolder(this.collection)
	},

	computed: {
		...mapGetters(['isAdmin', 'userRoles']),

		adminMode() {
			// True if global admin or user has role <Collection>_Admin
			const adminRole = `${this.collection}_Admin`
			return this.isAdmin || this.userRoles.includes(adminRole)
		}
	},

	methods: {
		newCollection() {
			this.showDialog()
		},

		clearActiveCollection(){
			this.activeCollection = {
				title: '',
				files: []
			}
		},

		filterCollections(collections){
			const filterRegex = /(.*)\//
			let filteredCollection = []
			for(const col in collections){
				collections[col].match(filterRegex) ? '' : filteredCollection.push(collections[col])
			}

			return filteredCollection
		},
		async setBaseFolder(title) {
			FileService.setGlobalFolder(title)

			try {
				const unfilteredCollections = await FileService.getCollections()
				this.allCollections = unfilteredCollections
				localStorage.setItem('currentParentFolder', JSON.stringify(unfilteredCollections))
				const filteredCollection = this.filterCollections(unfilteredCollections)
				this.collections = filteredCollection
				
			} catch (error) {
				Messages.showError(error)
			}
		},

		async showCollection(collection) {
			Messages.showLoading()

			try {
				this.setBaseFolder(this.collection)
				this.$refs.activeFolder.setActiveFolderName(collection)
				let files = await FileService.getFiles(collection)
				this.activeCollection.title = collection
				this.activeCollection.files = files
				localStorage.setItem('currentFileList', JSON.stringify(files))

				Messages.showSuccess('loaded')
			} catch (error) {
				Messages.showError(error)
			}
		},
		async uploadFile(data) {
			const { name, file } = data
			return await FileService.uploadFile(name, file)
		},
		async removeCollection(collection) {
			try {
				await FileService.removeCollection(collection)
				const index = this.collections.findIndex((e) => e == collection)
				index !== -1 ? this.clearActiveCollection() : ''
				this.removeChilrenFilesOnCollectionDelete()
				this.removeCollectionChildrenFolders(collection)
				index !== -1 ? this.collections.splice(index, 1) : this.removeChildCollectionDisplay(collection)
				bus.$emit('show-message', Messages.SUCCESS('deleted'))
			} catch (error) {
				bus.$emit('show-message', Messages.ERROR(error))
			}
		},
		async removeChilrenFilesOnCollectionDelete(){
			const currentFileList = JSON.parse(localStorage.getItem('currentFileList'))
			for(let file in currentFileList){
				try{
					await FileService.removeFile(currentFileList[file].key)
				}	
				catch (error) {
				Messages.showError(error)
			}
			}
		},
		async removeCollectionChildrenFolders(collection){
				let currentParentFolder = JSON.parse(localStorage.getItem('currentParentFolder'))
				var regex = new RegExp('^'+collection, 'gi');
				for(let i = 0; i < currentParentFolder.length; i++){
					if(currentParentFolder[i].match(regex)){
						try {
							await FileService.removeCollection(currentParentFolder[i]) 
						}
						catch (error) {
							bus.$emit('show-message', Messages.ERROR(error))
						}
					} 
				}
		},
		removeChildCollectionDisplay(collection){
				const filterRegex = /(.*)\//
				const changedTitle = collection.match(filterRegex)[1]
				this.showCollection(changedTitle)
				this.$refs.activeFolder.removeCollectionDisplay(collection)
		},
		async removeFile(key, title) {
			Messages.showLoading()

			try {
				await FileService.removeFile(key)

				// Remove file from list
				const { files } = this.activeCollection
				const index = files.findIndex((e) => e.key == key)
				this.$refs.activeFolder.setActiveFolderName(title)
				this.$refs.activeFolder.showCollection(title)
				Messages.showSuccess('deleted')
			} catch (error) {
				
				Messages.showError(error)
			}

		},

		async showDialog() {
			var result = await this.$dialog.showAndWait(Dialog, {
				title: 'Add New File Collection',
				component: FileCollectionForm,
				data: {},
				icon: false,
				width: 600,
				hideDelete: true
			})

			// If action is not save, the dialog was cancelled
			if (!result || result.action != 'save') return
			const {
				dialogData: { title }
			} = result

			try {
				Messages.showSaving()
				await FileService.createCollection(title)
				this.collections.push(title)
				Messages.showSuccess('inserted')
			} catch (error) {
				Messages.showError(error)
			}
		}
	}
}
</script>
